import React from "react";
import { Link } from "react-router-dom";

const Health = () => {
  return (
    <>
      <section
        className="page-title-section bg-img cover-background top-position1 left-overlay-secondary"
        data-overlay-dark="85"
        style={{ backgroundImage: "url('/img/banner/banner-health.jpg')" }}
      >
        <div className="container">
          <div className="row position-relative z-index-9">
            <div className="col-md-12">
              <h1>Health</h1>
              <ul>
                <li>
                  <Link to="/">Home</Link>
                </li>
                <li>Health</li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      <section>
        <div className="container">
          <div className="row mt-n2-9">
            <div className="col-lg-4 mt-2-9 order-2 order-lg-1">
              <div className="sidebar me-xl-1-9">
                <div className="widget mb-1-9">
                  <h2 className="mb-4 h4">Our Work</h2>
                  <ul className="list-unstyled menu m-0">
                    {[
                      { name: "Skill Development", path: "/skill-development" },
                      { name: "Education", path: "/education" },
                      { name: "Health", path: "/health", active: true },
                      {
                        name: "Inclusion of Differently Abled",
                        path: "/abled",
                      },
                      { name: "Sports", path: "/sports" },
                      {
                        name: "Community Initiatives",
                        path: "/community-initiatives",
                      },
                      { name: "Livelihoods", path: "/livelihoods" },
                    ].map((item, idx) => (
                      <li key={idx} className={item.active ? "active" : ""}>
                        <Link to={item.path}>
                          {item.name}
                          <i className="ti-arrow-right"></i>
                        </Link>
                      </li>
                    ))}
                  </ul>
                </div>

                <div className="widget mb-1-9">
                  <h2 className="mb-4 h4">Follow us</h2>
                  <div className="widget-content">
                    <ul className="social-icon-style2 list-unstyled ps-0">
                      <li className="me-1 d-inline-block"><Link to="https://www.facebook.com/www.shamayitamath.org?mibextid=ZbWKwL"target="blank"><i className="fab fa-facebook-f"></i></Link></li>
                      <li className="me-1 d-inline-block"><Link to="https://youtube.com/@shamayitamath2956?si=s7HKE99MD6pY6Kpb"target="blank"><i className="fa-brands fa-youtube"></i></Link></li>
                      <li className="me-1 d-inline-block"><Link to="https://www.instagram.com/shamayitamath?utm_source=ig_web_button_share_sheet&igsh=ODdmZWVhMTFiMw=="target="blank"><i className="fab fa-instagram"></i></Link></li>
                      <li className="me-0 d-inline-block"><Link to="https://www.linkedin.com/company/shamayitamath/?viewAsMember=true"target="blank"><i className="fab fa-linkedin-in"></i></Link></li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-lg-8 mt-2-9 order-1 order-lg-2">
              <div>
                {/* You can extract the rest of the content into smaller components or continue adding here */}
                <div className="mb-1-9 mb-lg-5 image-hover">
                  <img
                    src="/img/service/service-details-health.jpg"
                    alt="..."
                    className="border-radius-10"
                  />
                </div>

                <p className="mb-3">
                  Access to good healthcare services is essential to maintain a
                  healthy and active life. However, it is difficult to find the
                  required level of healthcare infrastructure in many rural
                  parts of the country or they are located at a distance.
                  Besides, financial constraints also hinder access to these
                  services. In light of this, Shamayita Math has adopted a
                  comprehensive approach to make good quality healthcare
                  services available to the rural populace in Bankura. This is
                  achieved through Matribedi Shamayita Jeeban Surya Hospital, a
                  full-fledged hospital. The hospital also extends its services
                  through convergence with government health schemes. Moreover,
                  mobile dispensaries and health camps provide essential medical
                  services to the unreached in remote rural locations.
                </p>
                <h2
                  className="mb-4 wow fadeInUp text-primary pt-3"
                  data-wow-delay="100ms"
                >
                  Matribedi Shamayita Jeeban Surya Hospital:
                </h2>
                <h4 className="mb-4 wow fadeInUp pt-3" data-wow-delay="100ms">
                  Enabling Access to Quality Medical Care
                </h4>

                {/* Hospital Overview */}
                <div className="row align-items-center mb-1-9">
                  <div
                    className="col-xl-6 mb-4 mb-xl-0 wow fadeInUp"
                    data-wow-delay="100ms"
                  >
                    <div className="image-hover">
                      <img
                        src="/img/service/health-1.jpg"
                        alt="..."
                        className="border-radius-10"
                      />
                    </div>
                  </div>
                  <div className="col-xl-6 wow fadeInUp" data-wow-delay="100ms">
                    <p className="mb-0">
                      Recognizing the cruciality of providing timely, adequate,
                      and quality medical services, Shamayita Math operates
                      Matribedi Shamayita Jeeban Surya Hospital, a full-scale
                      medical facility. The hospital and its outreach services
                      have served more than 150,000 people residing in the rural
                      areas of Bankura.
                    </p>
                  </div>
                </div>

                {/* Evolution */}
                <h4 className="mb-4 wow fadeInUp pt-3" data-wow-delay="100ms">
                  Evolution Over Years
                </h4>
                <div className="row align-items-center mb-1-9">
                  <div className="col-xl-6 wow fadeInUp" data-wow-delay="100ms">
                    <p className="mb-0">
                      The origin of the hospital lies in a health clinic called
                      "Jeeban Surya," set up in 1986, which provided homeopathic
                      care and treatment to the disadvantaged population of the
                      area. Having established itself in the area, the clinic
                      advanced to offer allopathic services, which saw renowned
                      doctors and surgeons getting associated with it. With the
                      soaring demand, a new "Jeeban Surya" building was
                      developed in 2001 serving as the Out-patient Department
                      (OPD). June 2008 marked the addition of an eye operation
                      theatre and with that started the cataract surgeries. The
                      year 2012 turned out to be a critical landmark as it
                      evolved into a full-service hospital with the inclusion of
                      an In-patient Department (IPD).
                    </p>
                  </div>
                  <div
                    className="col-xl-6 mb-4 mb-xl-0 wow fadeInUp"
                    data-wow-delay="100ms"
                  >
                    <div className="image-hover">
                      <img
                        src="/img/service/health-2.jpg"
                        alt="..."
                        className="border-radius-10"
                      />
                    </div>
                  </div>
                </div>

                {/* Services Offered */}
                <h4 className="mb-4 wow fadeInUp pt-3" data-wow-delay="100ms">Services Offered</h4>
                  <p className="mb-2">
                    <strong>The Hospital, today, offers a wide range of medical services, as listed below.</strong>
                  </p>

                  <div className="row align-items-center mb-1-9">
                    <div className="col-xl-6 mb-4 mb-xl-0 wow fadeInUp" data-wow-delay="100ms">
                      <div className="image-hover">
                        <img src="img/service/health-3.jpg" alt="..." className="border-radius-10" />
                      </div>
                    </div>
                    <div className="col-xl-6 wow fadeInUp" data-wow-delay="100ms">
                      <p className="mb-0">
                        Recognizing the cruciality of providing timely, adequate, and quality medical services, Shamayita Math operates Matribedi Shamayita Jeeban Surya Hospital, a full-scale medical facility. The hospital and its outreach services have served more than 150,000 people residing in the rural areas of Bankura.
                      </p>
                    </div>
                  </div>

                  <p className="mb-2">
                    <strong>The Hospital, today, offers a wide range of medical services, as listed below.</strong>
                  </p>
                  <ul className="list-unstyled list-style02 last border-bottom pb-4 mb-4">
                    <li>Outpatient care with specialist doctors.</li>
                    <li>A 35-bed in-patient department.</li>
                    <li>A 24x7 pharmacy and ambulance service.</li>
                    <li>A well-equipped diagnostic laboratory offering X-ray, ECG, Ultrasonography, and Colour Doppler service.</li>
                    <li>Also provides cashless service under the Swastha Sathi scheme.</li>
                  </ul>

                {/* Impact */}
                <h4 className="mb-4 wow fadeInUp" data-wow-delay="100ms">
                  Impacts:
                </h4>
                <div className="row mb-1-9 wow fadeInUp" data-wow-delay="100ms">
                  <div className="col-md-6 mb-4 mb-md-0">
                    {[
                      "A comprehensive range of healthcare services is available under one roof.",
                      "Reduced disparity in access to good healthcare services.",
                      "The availability of skilled healthcare professionals ensures the provision of specialized care.",
                      "Advanced medical technology and equipment have raised the quality of care.",
                    ].map((text, i) => (
                      <div
                        key={i}
                        className={`d-flex align-items-center border border-color-light-black p-2 ${
                          i !== 3 ? "mb-3" : ""
                        }`}
                      >
                        <i className="fa-solid fa-circle-check display-26 text-primary"></i>
                        <span className="ms-3 text-dark fw-bold">{text}</span>
                      </div>
                    ))}
                  </div>

                  <div className="col-xl-6 mb-4 mb-xl-0 wow fadeInUp" data-wow-delay="100ms">
                    <div className="image-hover">
                      <img
                        src="img/service/health-4.jpg"
                        alt="..."
                        className="border-radius-10"
                      />
                    </div>
                  </div>
                </div>


                {/* Mobile Medical Camps */}
                <h2
                  className="mb-4 wow fadeInUp text-primary pt-3"
                  data-wow-delay="100ms"
                >
                  Mobile Medical Camps:
                </h2>
                <h4 className="mb-4 wow fadeInUp pt-2" data-wow-delay="150ms">
                  Lack of Access to Healthcare
                </h4>
                <div className="row align-items-center mb-1-9">
                  <div className="col-xl-6 wow fadeInUp" data-wow-delay="100ms">
                    <p className="mb-0">
                      The Matribedi Shamayita Jeeban Surya Hospital regularly
                      came across a huge number of socially disadvantaged people
                      from rural areas unable to access either government or
                      private hospitals due to their presence in remote
                      locations, poor road connectivity, and lack of awareness
                      of government healthcare facilities.
                    </p>
                  </div>
                  <div
                    className="col-xl-6 mb-4 mb-xl-0 wow fadeInUp"
                    data-wow-delay="100ms"
                  >
                    <div className="image-hover">
                      <img
                        src="/img/service/health-mobile-1.jpg"
                        alt="..."
                        className="border-radius-10"
                      />
                    </div>
                  </div>
                </div>

                <h4 className="mb-4 wow fadeInUp pt-2" data-wow-delay="150ms">
                  Mobile Dispensary and Health Camps
                </h4>
                <div className="row align-items-center mb-1-9">
                  <div
                    className="col-xl-6 mb-4 mb-xl-0 wow fadeInUp"
                    data-wow-delay="100ms"
                  >
                    <div className="image-hover">
                      <img
                        src="/img/service/health-mobile-2.jpg"
                        alt="..."
                        className="border-radius-10"
                      />
                    </div>
                  </div>
                  <div className="col-xl-6 wow fadeInUp" data-wow-delay="100ms">
                    <p className="mb-0">
                      To fill this gap in rural healthcare, mobile dispensaries
                      have been put in service through which camps on general
                      medicine and special clinics are organized in four remote
                      villages around Durgapur. Besides medical consultation, a
                      team of qualified doctors holds health awareness sessions
                      for the communities on nutrition, mother & child health,
                      dental hygiene, and communicable and non-communicable
                      diseases and so on, thereby raising the general level of
                      awareness on health and preventive aspects. Free cataract
                      screenings are also held and patients requiring surgery
                      are operated on. Children with cleft are treated in
                      partnership with Operation Smile. Patients who require
                      admission and can receive cashless treatment through
                      Swasthya Sathi are sent to Jeeban Surya Hospital.
                    </p>
                  </div>
                </div>

                <h4 className="mb-4 wow fadeInUp pt-2" data-wow-delay="150ms">
                  Impacts
                </h4>
                {[
                  "Increased access to healthcare services for unreached populations.",
                  "Reduction in morbidity and mortality rates in the served areas.",
                  "A cost-effective approach to providing service to underserved populations",
                  "Potential for follow-up and referral for higher-level treatment, if required.",
                  "A growing shift of people towards preventive care through constant awareness.",
                ].map((text, i) => (
                  <div
                    key={i}
                    className="d-flex align-items-center border border-color-light-black p-2 mb-3"
                  >
                    <i className="fa-solid fa-circle-check display-26 text-primary"></i>
                    <span className="ms-3 text-dark fw-bold">{text}</span>
                  </div>
                ))}

                {/* Government Health Schemes */}
                <h2
                  className="mb-4 wow fadeInUp text-primary pt-3"
                  data-wow-delay="100ms"
                >
                  Partnering with Government Health Schemes:
                </h2>
                <p className="mb-2">
                  <strong>
                    A range of services in synergy with the government health
                    schemes are also offered. These are listed below.
                  </strong>
                </p>
                <ul className="list-unstyled list-style02 last border-bottom pb-4 mb-4">
                  <li>
                    <strong>Diagnostic Laboratory:</strong> Under a
                    public-private partnership at Amarkanan Rural Hospital,
                    Bankura, a diagnostic laboratory has been operated since
                    2007, which conducts various pathological tests at
                    government-fixed prices for patients referred by the
                    hospital. This benefits around 10,000 patients annually.
                  </li>
                  <li>
                    <strong>Ambulance Services:</strong> Ambulances have been
                    operated at Amarkanan Rural Hospital and Kanchanpur Block
                    Primary Healthcare Center (BPHC) in Bankura district since
                    2005 and 2008 respectively under the 'Janani Surakshya
                    Yojna' and 'Matri Jan' schemes.
                  </li>
                  <li>
                    <strong>Rogi Sahayata Kendra:</strong> Shamayita Math runs
                    the Rogi Sahayata Kendra of Amarkanan Rural Hospital since
                    2015.
                  </li>
                  <li>
                    <strong>Cataract Operations:</strong> Free cataract
                    operations are held under the National Blindness Control
                    Programme.
                  </li>
                  <li>
                    Also provides cashless
                    service under the Swastha Sathi scheme.
                  </li>
                </ul>

                <h4 className="mb-4 wow fadeInUp" data-wow-delay="100ms">
                  Impacts:
                </h4>
                {[
                  "Low-cost or free medical services are available to vulnerable people.",
                  "Better coordination and collaboration have improved healthcare delivery.",
                  "Convergence has brought in optimal utilization of resources and better efficiency.",
                  "Lower disparity in access to healthcare facilities.",
                ].map((text, i) => (
                  <div
                    key={i}
                    className="d-flex align-items-center border border-color-light-black p-2 mb-3"
                  >
                    <i className="fa-solid fa-circle-check display-26 text-primary"></i>
                    <span className="ms-3 text-dark fw-bold">{text}</span>
                  </div>
                ))}
              </div>
              {/* Repeat for remaining sections using same structure */}
            </div>
          </div>
        </div>
        <div className="scroll-top-percentage">
          <span id="scroll-value"></span>
        </div>
      </section>
    </>
  );
};

export default Health;
